import { render, staticRenderFns } from "./VueCarousel.vue?vue&type=template&id=42478387&"
import script from "./VueCarousel.vue?vue&type=script&lang=js&"
export * from "./VueCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports